var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0493164,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#FFECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 26.3493C28.4548 26.3493 29.3705 25.97 30.0456 25.2949C30.7207 24.6197 31.1 23.7041 31.1 22.7493C31.1 21.7945 30.7207 20.8788 30.0456 20.2037C29.3705 19.5286 28.4548 19.1493 27.5 19.1493C26.5452 19.1493 25.6296 19.5286 24.9544 20.2037C24.2793 20.8788 23.9 21.7945 23.9 22.7493C23.9 23.7041 24.2793 24.6197 24.9544 25.2949C25.6296 25.97 26.5452 26.3493 27.5 26.3493ZM22.3987 37.1493C20.5769 37.1493 19.0422 35.6179 19.7394 33.9347C20.1616 32.9156 20.7803 31.9896 21.5603 31.2096C22.3403 30.4296 23.2663 29.8108 24.2855 29.3887C25.3046 28.9666 26.3969 28.7493 27.5 28.7493C28.6031 28.7493 29.6954 28.9666 30.7145 29.3887C31.7337 29.8108 32.6597 30.4296 33.4397 31.2096C34.2197 31.9896 34.8385 32.9156 35.2606 33.9347C35.9578 35.6179 34.4232 37.1493 32.6014 37.1493H22.3987Z",
    fill: "#F53838"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.68a94e35.svg";
export { ForwardRef as ReactComponent };